// ion platform (legacy) API (intended for use on ion pages)
// Copyright (c) 2009-2017 ion interactive, inc. All rights reserved.

function _lbapi_XhrFactory() { return new XMLHttpRequest; }
var _lbapi_nativeXhr = new _lbapi_XhrFactory();

var _lbapi_lb3id = _lbapi_lb3id || '';  // lb3id automatically assigned server-side
var _lbapi_asynchronous = true;         // asynchronous requests?

var _lbapi_3id_param = 'lb3id';
var _lbapi_rnd_param = 'rnd';
var _lbapi_tag_param = 'tag';

function _lbapi_urlencode(stg) {
    var retval = ''
    if (stg != null && stg != '') {
        retval = escape(stg);
        retval = retval.replace('+', '%2B');
        retval = retval.replace('/', '%2F');
    }
    return retval;
}

function _lbapi_idstg() {
    return '?' + _lbapi_3id_param + '=' + _lbapi_lb3id + '&' + _lbapi_rnd_param + '=' + parseInt(31777 * Math.random());
}

function liveballConvert(func) {
    if (_lbapi_asynchronous && typeof func !== 'function' &&
        window.ixp && window.ixp.runtime && typeof window.ixp.runtime.convert === 'function') {
        window.ixp.runtime.convert();
        return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/Outside/Convert.ashx' + _lbapi_idstg(), _lbapi_asynchronous);
    if (typeof func === 'function') {
        xhr.onreadystatechange = function () {
            if (this.readyState == XMLHttpRequest.DONE) {
                func();
            }
        }
    }
    xhr.send(null);
}

function liveballTag(tag, func) {
    if (tag == null || tag === '') return;

    if (_lbapi_asynchronous && typeof func !== 'function' &&
        window.ixp && window.ixp.runtime && typeof window.ixp.runtime.tag === 'function') {
        window.ixp.runtime.tag(tag);
        return;
    }

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/Outside/Tag.ashx' + _lbapi_idstg() + '&' + _lbapi_tag_param + '=' + _lbapi_urlencode(tag), _lbapi_asynchronous);
    if (typeof func === 'function') {
        xhr.onreadystatechange = function () {
            if (this.readyState == XMLHttpRequest.DONE) {
                func();
            }
        }
    }
    xhr.send(null);
}

function liveballData(name, value, func) {
    if (name == null || name === '' || value == null || value === '') return;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/Outside/Data.ashx' + _lbapi_idstg() + '&' + name + '=' + _lbapi_urlencode(value), _lbapi_asynchronous);
    if (typeof func === 'function') {
        xhr.onreadystatechange = function () {
            if (this.readyState == XMLHttpRequest.DONE) {
                func();
            }
        }
    }
    xhr.send(null);
}

function liveballDataPost(name, value, func) {
    if (name == null || name === '' || value == null || value === '') return;

    var xhr = new XMLHttpRequest();
    xhr.open('POST', '/Outside/Data.ashx', _lbapi_asynchronous);
    if (typeof func === 'function') {
        xhr.onreadystatechange = function () {
            if (this.readyState == XMLHttpRequest.DONE) {
                func();
            }
        };
    }

    var params = _lbapi_idstg() + '&' + name + '=' + _lbapi_urlencode(value);
    xhr.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
    xhr.setRequestHeader('Content-length', params.length);
    xhr.setRequestHeader('Connection', 'close');
    xhr.send(params);
}

function liveballScriptlet(scriptletId, responseCType, paramList) {
    if (scriptletId == null) return;

    var xhr = new XMLHttpRequest();
    xhr.open('GET', '/Outside/Scriptlet.ashx' + _lbapi_idstg() + '&scrid=' + scriptletId + '&rct=' + responseCType + '&rdata=' + _lbapi_urlencode(paramList), false);
    xhr.send(null);
    if (xhr.readyState == 4 && xhr.status == 200) {
        return xhr.responseText;
    }
    else {
        return ('{RequestState:' + xhr.readystate + ',HttpStatus:' + xhr.status + '}');
    }
}